/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MaterialModule as ɵa} from './lib/material/material.module';